import { StateCreator } from "zustand";

export interface MapViewState {
    masterLayerUrl: string;
    masterLayerAttribution: string;
    mapCenterLat?: number;
    mapCenterLng?: number;
}

export interface MapViewSlice {
    mapView: MapViewState;
    setMapView: (state: MapViewState) => void;
}

const initialMapViewState: MapViewState = {
    masterLayerAttribution: "",
    masterLayerUrl: "",
};

export const createMapViewSlice: StateCreator<MapViewSlice, [], [], MapViewSlice> = (set) => ({
    mapView: initialMapViewState,

    setMapView: (state) => set({ mapView: state }),
});
